const SafariView = {
  show: () => {},
  dismiss: () => {},
};

export { SafariView };
